import { Box, Skeleton } from "@luce/ui";

export function PackageDetailSkeleton() {
  return (
    <Box className="gap-spacing-lg p-spacing-lg border-luce-neutral-border-mediumEmphasis rounded-radius-lg flex flex-col md:border">
      <Box className="gap-spacing-xs flex flex-col">
        <Skeleton className="h-5 w-3/4" />
        <Skeleton className="h-4 w-1/2" />
      </Box>
      <Skeleton className="h-6 w-24" />
      {Array.from({ length: 5 }).map((_, index) => (
        <Box key={index} className="flex flex-row justify-between">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-4 w-32" />
        </Box>
      ))}
      <Skeleton className="h-6 w-24" />
      <Skeleton radius="lg" className="h-10 w-full" />
    </Box>
  );
}
